export const GAME = {
  CHESS: 'Chess',
  POOL: 'Pool',
  LEVELS: 'Levels',
  VILLAGER: 'Villager',
  NONE: 'none'
} as const;

export type GameState = typeof GAME[keyof typeof GAME];
